import React, { ChangeEvent, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  CardMedia,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from '@mui/icons-material/Close';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function AddSubscription() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };
  const [value, setValue] = React.useState({
    page: "0",
    gender: "0",
    single:"0"
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [activeTab, setActiveTab] = React.useState(0);
   const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState(0);
    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
  
    const [selectField1, setSelectField1] = React.useState('default');
    const handleChange2 = (event: SelectChangeEvent) => {
      setSelectField1(event.target.value as string);
    };
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Add Subscription
            </h1>
          </div>

          <div className="right_s">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>

        <div className="cards">
          <form>
            <div className="gap_m">
                <div className="control_group w_100">
              <label>Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={image}
                        alt="photo"
                      />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label
                  className="upload_image"
                  htmlFor="icon-button-file"
                >
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(
                      event: ChangeEvent<HTMLInputElement>
                    ) => {
                      const files = (
                        event.target as HTMLInputElement
                      ).files;
                      if (
                        files &&
                        files[0].type.includes("image")
                      ) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage(
                          "This field only accepts images."
                        );
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="icon"
                        />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            <div className="control_group w_33">
                <label>Subscription For</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  value={value.single}
                  name="single"
                  onChange={handleChange1}
                >
                  <MenuItem value="0" disabled>
               Select 
                  </MenuItem>

                  <MenuItem value="10">Single Membership </MenuItem>
                  <MenuItem value="20">Duo Membership</MenuItem>
           

                </Select>
              </div>


          

            

              <div className="control_group w_33">
                <label>Type</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  value={value.gender}
                  name="gender"
                  onChange={handleChange1}
                >
                  <MenuItem value="0" disabled>
                  Select subscription type
                  </MenuItem>

                  <MenuItem value="10">Monthly </MenuItem>
                  <MenuItem value="20">Quarterly</MenuItem>
                  <MenuItem value="30">Semiannually </MenuItem>
                  <MenuItem value="40">Yearly </MenuItem>

                </Select>
              </div>
                   <div className="control_group w_33">
                <label>Price</label>
                <TextField
                  placeholder="Enter Price"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>


                  <div className="control_group w_100" >
                     <label>Description</label>
                <TextField
                  placeholder="Enter description"
                  hiddenLabel
                  fullWidth
                  multiline={true}
                  minRows={5}
                ></TextField>
                  </div>

            </div>
          </form>
        </div>
      </MainContainer>
    </>
  );
}

export default AddSubscription;
